// Copyright (c) 2026. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { Chip } from '@mui/material';
import { ComponentProps, forwardRef } from 'react';

type ChipProps = ComponentProps<typeof Chip>;
type ChipVariant = ChipProps['variant'] | 'text';

export type StatusChipProps = Omit<ChipProps, 'variant' | 'size' | 'sx'> & {
  variant: ChipVariant;
};

/**
 * Generic status chip primitive. Supports a 'text' variant (no background,
 * no border); when variant is 'text', renders as 'outlined' with border
 * removed. Use domain-specific wrappers like ShipmentStatusChip or
 * FulfillmentOrderStatusChip instead of this component directly.
 */
export const StatusChip = forwardRef<HTMLDivElement, StatusChipProps>(
  function StatusChip(props, ref) {
    const { variant } = props;

    const isTextVariant = variant === 'text';
    const chipVariant: ChipProps['variant'] = isTextVariant
      ? 'outlined'
      : variant;

    return (
      <Chip
        {...props}
        ref={ref}
        size="small"
        variant={chipVariant}
        sx={isTextVariant ? { border: 'none' } : undefined}
      />
    );
  }
);
